import React, { useRef, useState } from 'react';
import { Button, Text, Image, Badge } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import SCWidgetCard from '@/components/sc-controls/widgets/new/sc-widget-card';
import { WidgetConfig } from '@/PageComponents/Dashboard/DashboardModels';
import Fetch from '@/utils/Fetch';
import styles from '@/components/sc-controls/widgets/new/sc-widget-feedbear.module.css';

interface SCWidgetFeedbearProps {
  widget: WidgetConfig;
  onDismiss?: () => void;
}

const SCWidgetFeedbear: React.FC<SCWidgetFeedbearProps> = ({ widget, onDismiss }: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const iframeRef = useRef<HTMLIFrameElement | null>(null);

  const { refetch } = useQuery({
    queryKey: ['feedbear-token'],
    queryFn: () => Fetch.get({ url: '/feedbear/fbsessiontoken' }),
    enabled: false,
  });

  const handleFeedbackClick = async () => {
    setIsLoading(true);
    try {
      const { data: response } = await refetch();
      
      if (response?.fbsessiontoken) {
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = `https://servcraft.feedbear.com/sso/auth?payload=${response.fbsessiontoken}`;
        iframeRef.current = iframe;
        document.body.appendChild(iframe);
        
        iframe.onload = () => {
          setTimeout(() => {
            window.open('https://servcraft.feedbear.com/roadmap', '_blank');
            if (iframeRef.current?.parentNode) {
              document.body.removeChild(iframeRef.current);
            }
            iframeRef.current = null;
            setIsLoading(false);
          }, 1000);
        };
      }
    } catch (error) {
      console.error('Failed to get Feedbear SSO URL:', error);
      setIsLoading(false);
    }
  };

  return (
    <SCWidgetCard height={widget.heightPX} onDismiss={onDismiss}>
      <div className={styles.wrapper}>
        <div className={styles.row}>
          <div className={styles.textCol}>
            <Text size="xl" fw={700} lh={1.3}>
              Our roadmap, your ideas.
            </Text>

            <Text size="sm" lh={1.5} mt="md">
              Submit your ideas and see what features are coming soon.
            </Text>

            <Button
              size="sm"
              onClick={handleFeedbackClick}
              loading={isLoading}
              mt="xs"
              w="fit-content"
            >
              Suggest and Explore
            </Button>
          </div>

          <Image
            className={styles.image}
            src="/widgets/feedbear-kanban.png"
            alt="Roadmap"
            w={280}
            h="auto"
            fit="contain"
          />
        </div>
      </div>
    </SCWidgetCard>
  );
};

export default SCWidgetFeedbear;